import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CoreLink } from '@uncinc/react-drupal-core';
import MapContext from '../../../MapContext';
import ProgressIndicator from '../../../ProgressIndicator';

import './style.scss';

const MAX_DISPLAY_DISTANCE = 500000;

const SearchItem = ({ item }) => {
  const { t } = useTranslation();
  const fieldActivityDatetime = item.fields.field_activity_datetime && item.fields.field_activity_datetime[0];
  const endValue = item.fields.end_value && item.fields.end_value[0];
  const fieldMaxVolunteers = item.fields.field_max_volunteers && item.fields.field_max_volunteers[0];
  const placesAvailable = item.fields.places_available && item.fields.places_available[0];
  const projectType = item.fields.project_type_name ? item.fields.project_type_name[0] : 'nldoet_flag';

  const dateStart = new Date(fieldActivityDatetime * 1000);
  const dateEnd = new Date(endValue * 1000);
  const iconClass = `icon-${projectType.toLowerCase()}`;
  const progress = (parseFloat(fieldMaxVolunteers) - parseFloat(placesAvailable)) / parseFloat(fieldMaxVolunteers);

  // Conditionally use MapContext only if it exists
  let setSelectedProject = null;
  try {
    const mapContext = useContext(MapContext);
    setSelectedProject = mapContext?.setSelectedProject;
  } catch (error) {
    // MapContext doesn't exist or is not available
    setSelectedProject = null;
  }

  return (
    <article
      className="SearchItem"
      onMouseOver={() => setSelectedProject && setSelectedProject(item.id)}
    >
      <div className="row">
        <div className="SearchItem__buttonwrapper col-4">
          <i className={`icon icon-project-default ${iconClass} icon--large`} />
          <CoreLink className={`Button Button--primary ${item.fields.field_project_full[0] ? 'disabled' : ''}`} href={item.fields.url[0]}>{t('search_nldoet.subscribe')}</CoreLink>
          <div className="SearchItem__status">
            <ProgressIndicator progress={progress} />
            <div className="SearchItem__availability">
              {item.fields.field_project_full[0] === true
                ? <span>{t('search_nldoet.project_full')}</span>
                : <span>{item.fields.places_available[0]} / {item.fields.field_max_volunteers[0]} beschikbaar</span>}
            </div>
          </div>
        </div>
        <div className="col-8 SearchItem__info">
          <h5>
            <CoreLink href={item.fields.url[0]}>{item.fields.title[0]}</CoreLink>
          </h5>
          <div className="SearchItem__date">
            <div>
              <span className="SearchItem__date">
                {dateStart.toLocaleDateString('nl-NL', { weekday: 'long' }).replace(/^./, (c) => c.toUpperCase())}
                &nbsp;
                {dateStart.getDate()}-{(dateStart.getMonth() + 1).toString().padStart(2, '0')}-{dateStart.getFullYear()}
                ,
                &nbsp;
              </span>
              <span className="SearchItem__date__time">
                {dateStart.getHours().toString().padStart(2, '0')}:{dateStart.getMinutes().toString().padStart(2, '0')}
                &nbsp;-&nbsp;
                {dateEnd.getHours().toString().padStart(2, '0')}:{dateEnd.getMinutes().toString().padStart(2, '0')}
              </span>
            </div>
          </div>
          <div className="SearchItem__location">{item.fields.address_line1[0]}, {item.fields.locality[0]}</div>
          {item.distance && item.distance < MAX_DISPLAY_DISTANCE && <div className="SearchItem__distance"><span>{parseInt(item.distance / 1000)} km</span></div>}
        </div>
      </div>
    </article>
  );
};

export default SearchItem;
